module.exports = new __parcel__URL__("elationemr-logo.b383e863.png").toString();